import { createVNode as _createVNode } from "vue";
/**
 * @author wuluoting
 * @fileoverview pc-banner
 */

import { defineComponent } from "vue";
// assets
import kt1Url from "@/assets/img/pc/kt1.png";
import kt2Url from "@/assets/img/pc/kt2.png";
// import kt3Url from "@/assets/img/pc/kt3.png";

export default defineComponent({
  name: "PcBanner",
  setup() {
    return () => {
      const bannerBox = _createVNode("div", {
        "class": "banner-box"
      }, [_createVNode("img", {
        "class": "kt1",
        "src": kt1Url
      }, null), _createVNode("img", {
        "class": "kt2",
        "src": kt2Url
      }, null)]);
      return _createVNode("div", {
        "id": "backtop",
        "class": "pc-banner"
      }, [bannerBox]);
    };
  }
});